// extracted by mini-css-extract-plugin
module.exports = {"container":"PaymentInformationCheckDisplay_container__2J1jF"};